import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA1');

    return (
        <>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <img src="https://websiteoss.ecoflow.com/upload/image/1741257315580/Frame%201612690127.jpg" className="demo-img-center" />
        </>
    );
}
